/* This file will contain those urls which are not common across projects
 * For eg, document urls differ from RP to TC project
 * If URLS are not defined here, default URLS from module will be used (which may break your application)
 */

import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const DOCUMENTS_URLS = {
  DOCUMENTS: {
    ROOT: `${PRIVATE_ROOT}/suite/documents`,
    ARCHIVE: `${PRIVATE_ROOT}/suite/documents/archive`,
  },
  UPLOAD_DOCUMENT: `${PRIVATE_ROOT}/suite/upload-document`,
  VIEW_DOCUMENT: `${PRIVATE_ROOT}/suite/document/:id`,
  SIGN_DOCUMENT: `${PRIVATE_ROOT}/suite/sign-document/:id`,
  SURVEY: `${PRIVATE_ROOT}/suite/survey/:id`,
  CUSTOM_FORM: `${PRIVATE_ROOT}/suite/custom-form/:id`,
}

export const INSURANCE_URLS = {
  ROOT: `${PRIVATE_ROOT}/suite/insurance`,
  ADD_INSURANCE: `${PRIVATE_ROOT}/suite/add-insurance`,
  ADD_EXISTING_INSURANCE: `${PRIVATE_ROOT}/suite/add-existing-insurance`,
  EDIT_EXISTING_INSURANCE: `${PRIVATE_ROOT}/suite/:id/edit-existing-insurance`,
  VIEW_EXISTING_INSURANCE: `${PRIVATE_ROOT}/suite/:id/view-existing-insurance`,
}

export const INSPECTIONS_URLS = {
  INSPECTIONS: {
    ROOT: `${PRIVATE_ROOT}/suite/inspections`,
    COMPLETED: `${PRIVATE_ROOT}/suite/inspections/completed`,
  },
  REVIEW_INSPECTION: `${PRIVATE_ROOT}/suite/inspection/:id/review`,
  VIEW_INSPECTION: `${PRIVATE_ROOT}/suite/inspection/:id`,
}

export const MAINTENANCE_URLS = {
  MAINTENANCE: {
    ROOT: `${PRIVATE_ROOT}/suite/maintenance`,
    PAST_REQUESTS: `${PRIVATE_ROOT}/suite/maintenance/past-requests`,
    PHONE_NUMBERS: `${PRIVATE_ROOT}/suite/maintenance/phone-numbers`,
    HOME: `${PRIVATE_ROOT}/suite`,
  },
  ADD_MAINTENANCE_REQUEST: `${PRIVATE_ROOT}/suite/add-maintenance-request`,
  VIEW_MAINTENANCE_REQUEST: `${PRIVATE_ROOT}/suite/maintenance-request/:id`,
  EDIT_MAINTENANCE_REQUEST: `${PRIVATE_ROOT}/suite/maintenance-request/:id/edit`,
}

export const RENTABLE_ITEMS_URLS = {
  RENTABLE_ITEMS: {
    ROOT: `${PRIVATE_ROOT}/suite/rentable-items`,
    RENTED_ITEMS: `${PRIVATE_ROOT}/suite/rentable-items/rented-items`,
  },
  VIEW_RENTABLE_ITEM: `${PRIVATE_ROOT}/suite/rentable-item/:id`,
  EDIT_RENTABLE_ITEM: `${PRIVATE_ROOT}/suite/rentable-item/:id/edit`,
}

export const USERS_URLS = {
  ROOT: `${PRIVATE_ROOT}/suite/users`,
}

export const AMENITIES_URLS = {
  ROOT: `${PRIVATE_ROOT}/suite/amenities`,
}

export const COMMERCIAL_URLS = {
  ROOT: `${PRIVATE_ROOT}/suite/commercial`,
}
